var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassionFruit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0441 20.7945C17.2113 25.6273 9.37589 25.6273 4.54313 20.7945C-0.289626 15.9618 -0.289626 8.12633 4.54313 3.29357C9.37589 -1.53919 13.6778 1.99437 18.5106 6.82713C23.3433 11.6599 26.8769 15.9618 22.0441 20.7945Z",
    fill: "#82244E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3675 19.6329C20.3668 22.6336 14.0165 21.1485 9.18376 16.3157C4.351 11.4829 2.86584 5.13263 5.86658 2.1319C8.86731 -0.868835 15.2176 0.616315 20.0504 5.44908C24.8831 10.2818 26.3683 16.6321 23.3675 19.6329Z",
    fill: "#E3CA48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63531 4.0142C6.63531 4.0142 10.6092 3.92971 12.8005 6.15028C14.9919 8.37085 13.2731 8.46603 15.0554 10.4529M15.0554 10.4529C16.8377 12.4397 15.5147 13.2489 16.9756 14.8267C18.4365 16.4045 22.8485 16.6966 22.8485 16.6966M15.0554 10.4529C15.0554 10.4529 10.8027 7.69173 9.35908 8.76104C7.9155 9.83035 8.40972 12.7167 8.40972 12.7167M15.0554 10.4529C15.0554 10.4529 19.8326 14.6747 20.8306 9.9836M15.0554 10.4529C15.0554 10.4529 18.3055 7.03941 15.7035 3.58197M15.0554 10.4529C15.0554 10.4529 13.3939 11.6883 12.8005 13.7452C12.2072 15.8022 13.3148 17.424 13.3148 17.424",
    stroke: "black",
    strokeOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3069 18.5722C21.3076 19.5715 19.5835 19.9843 17.3043 19.4513C15.0507 18.9242 12.4951 17.5057 10.2444 15.255C7.99374 13.0044 6.57523 10.4487 6.04819 8.1952C5.51515 5.91597 5.92793 4.19187 6.92724 3.19256C7.92655 2.19325 9.65065 1.78047 11.9299 2.31351C14.1834 2.84055 16.739 4.25906 18.9897 6.50974C21.2404 8.76041 22.6589 11.3161 23.1859 13.5696C23.719 15.8488 23.3062 17.5729 22.3069 18.5722Z",
    stroke: "#F2F2F2",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1908 19.4561C21.7739 20.873 19.5384 21.2575 17.0196 20.6684C14.505 20.0803 11.7493 18.5277 9.36054 16.1389C6.97178 13.7502 5.41913 10.9944 4.83105 8.47985C4.24196 5.96101 4.62651 3.72553 6.04336 2.30867C7.46022 0.891817 9.6957 0.507275 12.2145 1.09636C14.7291 1.68444 17.4848 3.23709 19.8736 5.62585C22.2624 8.01461 23.815 10.7704 24.4031 13.2849C24.9922 15.8038 24.6076 18.0392 23.1908 19.4561Z",
    stroke: "#A03A68",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassionFruit);
export default __webpack_public_path__ + "static/media/passionFruit.4cc604e2b69cdc40a3a633d4e018e4f6.svg";
export { ForwardRef as ReactComponent };